import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Text } = Typography;

/** Refresh button + relative "Updated X ago" for the webstore catalog cache. */
const CatalogFreshness = ({
  fetchedAt, refreshing, onRefresh, disabled,
}) => {
  // Re-render every 60s so "X minutes ago" stays accurate without refetching.
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!fetchedAt) {
      return undefined;
    }
    const id = setInterval(() => setTick((n) => n + 1), 60000);
    return () => clearInterval(id);
  }, [fetchedAt]);

  return (
    <>
      {fetchedAt && (
        <Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
          {`Updated ${dayjs(fetchedAt).fromNow()}`}
        </Text>
      )}
      <Button
        icon={<ReloadOutlined />}
        loading={refreshing}
        onClick={onRefresh}
        disabled={disabled || refreshing}
      >
        Refresh
      </Button>
    </>
  );
};

CatalogFreshness.propTypes = {
  fetchedAt: PropTypes.string,
  refreshing: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CatalogFreshness.defaultProps = {
  fetchedAt: null,
  disabled: false,
};

export default CatalogFreshness;
